module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "pi"
    }
  }), _c('a', {
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    attrs: {
      "id": "piv"
    }
  }), _c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2001")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 1999 by Donna Morrissey")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Published by arrangement with Penguin Books Canada Limited")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _c('br'), _vm._v("\nMorrissey, Donna, date."), _c('br'), _vm._v("\nKit’s law / Donna Morrissey.—1 st Mariner Books ed."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\n“A Mariner original.”"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-618-10927-2"), _c('br'), _vm._v("\n1. Teenage girls—Fiction. 2. Mothers and daughters—Fiction. 3. Mentally ill women—Fiction. 4. Newfoundland—Fiction. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("9199.3."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("6535 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("K")]), _vm._v("58 2001"), _c('br'), _vm._v("\n813'.54—dc21 00-065465")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-63055-7"), _c('br'), _vm._v("\nv3.0421")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("This is a work of fiction. Names, characters, and incidents are the product of the author’s imagination, except in the case of historical figures and events, which are used fictitiously.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0